import { render, staticRenderFns } from "./productDcmm.vue?vue&type=template&id=7ab85869&scoped=true&"
import script from "./productDcmm.vue?vue&type=script&lang=js&"
export * from "./productDcmm.vue?vue&type=script&lang=js&"
import style0 from "./productDcmm.vue?vue&type=style&index=0&id=7ab85869&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab85869",
  null
  
)

export default component.exports